import { useEffect, useState } from 'react';
import { Loader2, X } from 'lucide-react';
import { warehouseApi, apiError } from '../shared/warehouseApi';

export function UnbatchedReturnsModal({ onClose }) {
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    setData(null);
    setError('');
    warehouseApi.get('/api/admin/return-handoffs/unbatched', { params: { page } })
      .then(response => { if (active) setData(response.data); })
      .catch(err => { if (active) setError(apiError(err)); });
    return () => { active = false; };
  }, [page]);
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" role="dialog" aria-modal="true" aria-label="Devoluciones sin lote">
    <div className="flex max-h-[85vh] w-full max-w-3xl flex-col rounded-2xl bg-white shadow-xl">
      <div className="flex items-center justify-between border-b p-5"><div><h2 className="text-lg font-bold">Escaneos sin lote</h2><p className="text-sm text-gray-500">Entregas a tienda reportadas por conductores sin un lote preparado.</p></div><button type="button" onClick={onClose} aria-label="Cerrar"><X size={20} /></button></div>
      <div className="overflow-auto p-5">
        {error && <p role="alert" className="text-red-700">{error}</p>}
        {!data && !error && <Loader2 className="animate-spin" />}
        {data?.handoffs.length === 0 && <p className="text-sm text-gray-500">Sin escaneos fuera de lote.</p>}
        {data?.handoffs.map(row => <div key={row.id} className="flex min-w-0 flex-wrap justify-between gap-2 border-b py-3 text-sm">
          <div><strong>{row.tracking_code}</strong><p>{row.store_name || `Tienda #${row.store_user_id || '—'}`}</p></div>
          <div className="text-right text-gray-500"><p>Conductor #{row.driver_user_id}</p><p>{new Date(row.scanned_at).toLocaleString('es-PE', { timeZone: 'America/Lima' })}</p></div>
        </div>)}
      </div>
      <div className="flex justify-end gap-3 border-t p-4 text-sm"><button type="button" disabled={page <= 1} onClick={() => setPage(page - 1)}>Anterior</button><span>{page}</span><button type="button" disabled={!data?.pagination?.has_next} onClick={() => setPage(page + 1)}>Siguiente</button></div>
    </div>
  </div>;
}
